import { useCurrentFrame, useVideoConfig, interpolate, AbsoluteFill } from "remotion";
import { loadFont as loadMontserrat } from "@remotion/google-fonts/MontserratAlternates";

const { fontFamily: mont } = loadMontserrat("normal", { weights: ["900"], subsets: ["latin"] });

export const ReelTextOverlay: React.FC<{ text: string; topPct: number; durationInFrames?: number }> = ({ text, topPct, durationInFrames }) => {
  const frame = useCurrentFrame();
  const { durationInFrames: compDur } = useVideoConfig();
  const dur = durationInFrames || compDur;
  const fadeIn  = interpolate(frame, [0, 5], [0, 1], { extrapolateRight: "clamp" });
  const fadeOut = interpolate(frame, [dur - 7, dur], [1, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  if (!text) return null;

  const words = text.trim().split(/\s+/);
  const lines: string[] = words.length >= 2
    ? [words.slice(0, Math.ceil(words.length / 2)).join(" "), words.slice(Math.ceil(words.length / 2)).join(" ")]
    : [text.trim()];

  return (
    <AbsoluteFill style={{ pointerEvents: "none" }}>
      <div style={{ position:"absolute", top:`${topPct}%`, left:"50%", transform:"translateX(-50%)", opacity: fadeIn*fadeOut, display:"flex", flexDirection:"column", alignItems:"center", gap:4 }}>
        {lines.map((line, i) => (
          <span key={i} style={{ color:"#ffffff", fontSize:48, fontWeight:900, fontFamily:mont, letterSpacing:"0.04em", whiteSpace:"nowrap", textShadow:"0 2px 6px rgba(0,0,0,0.85),0 1px 3px rgba(0,0,0,0.7)", lineHeight:1.1 }}>{line}</span>
        ))}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
